import { apiClient, API_CONFIG } from '../../core';
import type { ApiResponse } from '../../shared';
import { buildQueryString } from '../../shared';

import type { 
  LC_GetRolesOut, 
  LC_GetRoleByIdOut, 
  LC_CreateRoleOut, 
  LC_UpdateRoleOut,
  CreateRolePayload,
  UpdateRolePayload,
  RoleStatusPayload,
  GetRolesParams,
} from './roles.types';


export class RolesService {
  async getRoles(params: GetRolesParams): Promise<ApiResponse<LC_GetRolesOut>> {
    const queryString = buildQueryString(params);
    const endpoint = `${API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLES.LIST}${queryString}`;
    return apiClient.get<LC_GetRolesOut>(endpoint);
  }

  async getRoleById(id: string): Promise<ApiResponse<LC_GetRoleByIdOut>> {
    return apiClient.get<LC_GetRoleByIdOut>(API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLES.GET(id));
  }

  async createRole(payload: CreateRolePayload): Promise<ApiResponse<LC_CreateRoleOut>> {
    return apiClient.post<LC_CreateRoleOut>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLES.CREATE,
      payload,
      { skipUnauthorizedHandler: true },
    );
  }

  async updateRole(id: string, payload: UpdateRolePayload): Promise<ApiResponse<LC_UpdateRoleOut>> {
    return apiClient.put<LC_UpdateRoleOut>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLES.UPDATE(id),
      payload,
      { skipUnauthorizedHandler: true },
    );
  }

  async toggleRoleStatus(id: string, isEnabled: boolean): Promise<ApiResponse<void>> {
    const payload: RoleStatusPayload = { isEnabled };
    return apiClient.patch<void>(
      API_CONFIG.ENDPOINTS.AUTHORIZATION.ROLES.STATUS(id),
      payload,
      { skipUnauthorizedHandler: true },
    );
  }
}

export const rolesService = new RolesService();
